export const GET_ALL_DEPOSIT = 'GET_ALL_DEPOSIT'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_USER_DEPOSITS = 'GET_ALL_USER_DEPOSITS'
